import { RegistrationPromotionalCodeProps } from 'features/registration/interface/registration';
import { FC } from 'react';
import FormRow from 'shared/components/form/formRow';
import InputText from 'shared/components/form/inputText';
import useInputFocus from 'shared/hooks/useInputFocus';
import { findCookieValue } from 'shared/util/utility';

import { PromoCodeScratcher } from '../../../../../shared/components/PromoCodeScratcher/PromoCodeScratcher';
import { FeatureLoader, useShowRegistrationPromotionPickerFlag } from '../../../../../shared/featureFlags';
import { PromotionPicker } from '../../../../PromotionPicker';

const RegistrationStep8: FC<RegistrationPromotionalCodeProps> = ({
	isFieldValueValid,
	errors,
	touched,
	setFieldValue,
	values,
	handleBlur,
	t,
	setScratchedCode,
}) => {
	const inputRef = useInputFocus();
	const cookiePromoCode = findCookieValue('promo');
	const newRegisterPromotionPickerFlag = useShowRegistrationPromotionPickerFlag();
	return (
		<FeatureLoader>
			{newRegisterPromotionPickerFlag?.value ? (
				<PromotionPicker
					theme={'green'}
					onChangePromotion={(promotion) => setFieldValue('regPromotion', promotion)}
					initialPromotion={values.regPromotion}
					initialCode={values.regCode}
					onCodeChange={(code) => {
						setFieldValue('regCode', code);
					}}
				/>
			) : (
				<>
					<FormRow>
						<InputText
							autoFocus
							inputRef={inputRef}
							label={t('promoCodes')}
							name="regCode"
							isFieldValueValid={isFieldValueValid}
							errors={errors}
							touched={touched}
							onBlur={handleBlur}
							setFieldValue={setFieldValue}
							values={values}
							onChange={(e) => setFieldValue('regCode', e.target.value)}
							cyTestRef="reg-code"
							cyErrorRef="reg-validation-error"
						/>
					</FormRow>
					{!cookiePromoCode && <PromoCodeScratcher setPromoCodeScratched={setScratchedCode} />}
				</>
			)}
		</FeatureLoader>
	);
};

export default RegistrationStep8;
